import React, { Component } from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { reduxForm, Field } from 'redux-form';
import faCheck from '@fortawesome/fontawesome-pro-light/faCheck';

import { bookingFormInitialValues } from '../store/reducers';
import Select from './Select';
import { setStep } from '../store/actions';
import Language from '../enums/Language';
import Currency from '../enums/Currency';
import withLocalize from '../withLocalize';

class Header extends Component {

	handleClickSetStep = (e, step) => {
		e.preventDefault();

		const { dispatch, maxStep } = this.props;

		if (step > maxStep) return;

		dispatch(setStep(step));
	};

	render() {
		const { step: currentStep, currencies, translate: t } = this.props;

		if ( currentStep > 4 ) return null;

		return (
            <header className="header">
				<ul className="header-paginator">
					{[1,2,3,4].map((step, index) => (
						<li className="header-paginator__item" key={index}>
							<button
								className={`
									header-paginator__link
									${step < currentStep ? 'header-paginator__link--success' : ''}
									${step === currentStep ? 'header-paginator__link--current' : ''}
								`}
								onClick={e => this.handleClickSetStep(e, step)}
							>
								{step < currentStep ?
									<FontAwesomeIcon icon={faCheck} />
									:
									step
								}
							</button>
						</li>
					))}
				</ul>

				<div className="header-currency">
					<Field
						component={Select}
						name="currency"
						label={t('Header.currency')}
						options={Currency.getOptions(currencies)}
						format={(value) => value.id}
						normalize={(value) => currencies[value]}
						className="select-container--header"
					/>

					<Field
						component={Select}
						name="lang"
						label={t('Header.language')}
						options={Language.getOptions()}
						className="select-container--header"
					/>

				</div>
            </header>
		);
	}
}

export default compose(
	withRouter,
	reduxForm({
		form: 'bookingForm',
		initialValues: bookingFormInitialValues,
		destroyOnUnmount: false,
	}),
	connect((state) => ({
		step: state.app.step,
		maxStep: state.app.maxStep,
		currencies: state.app.currencies,
	})),
	withLocalize,
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.jsx